import { ChevronDown } from "lucide-react";
import { Button } from "./Button";

export interface CursorPaginationProps {
  hasNextPage: boolean;
  isLoading?: boolean;
  onLoadMore: () => void;
  loadedCount?: number;
}

export function CursorPagination({
  hasNextPage,
  isLoading = false,
  onLoadMore,
  loadedCount
}: CursorPaginationProps) {
  return (
    <div className="flex flex-col items-center gap-2 border-t border-zinc-200 px-4 py-4 dark:border-zinc-800">
      {loadedCount !== undefined ? (
        <p className="text-xs text-zinc-500 dark:text-zinc-400">
          {loadedCount} {loadedCount === 1 ? "registro carregado" : "registros carregados"}
        </p>
      ) : null}
      {hasNextPage ? (
        <Button variant="secondary" onClick={onLoadMore} isLoading={isLoading} loadingLabel="Carregando…">
          {!isLoading ? <ChevronDown className="size-4" aria-hidden="true" /> : null}
          Carregar mais
        </Button>
      ) : loadedCount !== undefined && loadedCount > 0 ? (
        <p className="text-xs text-zinc-500 dark:text-zinc-400">Todos os registros foram exibidos.</p>
      ) : null}
    </div>
  );
}
